export const MIN_COL_SIZE = 30;
export const RESIZE_INTERVAL = 40;

export const DATA_COL = 'data-rgCol';
export const DATA_ROW = 'data-rgRow';

export const DISABLED_CLASS = 'disabled';
export const CELL_CLASS = 'rgCell';
export const ROW_HEADER_TYPE = 'rowHeaders';
export const HEADER_CLASS = 'rgHeaderCell';
export const HEADER_SORTABLE_CLASS = 'sortable';
export const HEADER_ROW_CLASS = 'header-rgRow';
export const HEADER_ACTUAL_ROW_CLASS = 'actual-rgRow';

export const DRAG_ICON_CLASS = 'revo-drag-icon';
export const DRAGGABLE_CLASS = 'revo-draggable';

export const FOCUS_CLASS = 'focused-cell';
export const SELECTION_BORDER_CLASS = 'selection-border-range';
export const MOBILE_CLASS = 'mobile-handler';
export const TMP_SELECTION_BG_CLASS = 'temp-bg-range';

export const CELL_HANDLER_CLASS = 'autofill-handle';

export const EDIT_INPUT_WR = 'edit-input-wrapper';

export const DRAGG_TEXT = 'Draggable item';
export const GRID_INTERNALS = '__rvgr';
export const ROW_FOCUSED_CLASS = 'focused-rgRow';
